import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import MemberService from '@/services/UsersServices/MemberService';
import { extractError } from '@/helpers/extractApiError';

const model = {
    id: null,
    submitting: false,
    error: null,
    successOnDelete: '',
};

export const deleteMember = createAsyncThunk(
    'member/deleteMember',
    async (memberId, { rejectWithValue }) => {
        try {
            const response = await MemberService.deleteMember(memberId);
            return {
                memberId,
                data: response.data,
            };
        } catch (error) {
            return rejectWithValue(extractError(error));
        }
    },
);

const deleteMemberSlice = createSlice({
    name: 'deleteMember',
    initialState: model,
    reducers: {
        resetDeleteMemberStateOnError: (state) => {
            state.error = null;
        },
        resetDeleteMemberStateOnSuccess: (state) => {
            state.successOnDelete = '';
        },
    },
    extraReducers: (builder) => {
        // delete member
        builder.addCase(deleteMember.pending, (state, action) => {
            state.id = action.meta.arg;
            state.submitting = true;
        }).addCase(deleteMember.fulfilled, (state) => {
            state.id = null;
            state.submitting = false;
            state.successOnDelete = 'Member deleted successfully!';
        }).addCase(deleteMember.rejected, (state, action) => {
            state.submitting = false;
            state.error = extractError(action);
        });
    },
});

export const {
    resetDeleteMemberStateOnError,
    resetDeleteMemberStateOnSuccess,
} = deleteMemberSlice.actions;

export default deleteMemberSlice.reducer;
